import { Award, Headphones, Network, Server } from "lucide-react";
import LegalPage from "@/pages/legal/LegalPage";

const services = [
  { icon: Network, title: "Altyapıdan İnternet", desc: "Aynı altyapıdan hizmete daha uygun fiyata taahhütsüz ve kotasız internet." },
  { icon: Server, title: "Kurumsal Çözümler", desc: "İşletmelere özel yüksek performanslı fiber internet ve altyapı çözümleri." },
  { icon: Headphones, title: "Çağrı Merkezi", desc: "Müşterilerimize 08:00 - 20:00 hizmet veren yerel destek ekibimiz." },
  { icon: Award, title: "Teknik Servis", desc: "Sahada ve dijitalde hızlı çözümler üreten teknik ekibimiz." },
];

export default function AboutUs() {
  return (
    <LegalPage title="Hakkımızda" testId="legal-about">
      <div className="rounded-2xl border border-zinc-200 bg-[#faf9ff] p-7">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#ff9800]">ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİCARET LİMİTED ŞİRKETİ</p>
        <p className="mt-4 text-[15px] leading-relaxed text-gray-600">
          Mersin'in Silifke ilçesinde kurulan EntaNET, bölgesine yüksek hızlı ve güvenilir internet
          erişimi sunmayı amaç edinmiş bir internet servis sağlayıcısıdır. Altyapı İşletmeciliği ve
          İnternet Servis Sağlayıcılığı ile yetkilendirilmiş lisanslı firma olarak, bölgemizdeki her
          haneye ve işletmeye büyük şehir kalitesinde fiber internet hizmeti ulaştırmayı hedefliyoruz.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-gray-600">
          Kurulduğumuz günden bu yana, büyük operatörlerin yeterince yatırım yapmadığı bölgelere
          modern fiber altyapı taşıyor; yerel bir şirket olmanın gücüyle abonelerimize komşumuz gibi
          davranıyoruz. Teknik ekibimiz aynı gün müdahale, 08:00 - 20:00 destek ve şeffaf fiyatlandırma
          ilkeleriyle çalışır.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-gray-600">
          EntaNET tarafından yürütülen tüm hizmetler, Bilgi Teknolojileri ve İletişim Kurumu (BTK)
          tarafından denetlenmektedir.
        </p>
      </div>

      <h2 className="font-display text-xl font-bold text-[#101436]">Hizmetlerimiz</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {services.map((s) => (
          <div key={s.title} className="rounded-xl border border-zinc-200 bg-white p-6">
            <s.icon className="h-7 w-7 text-[#ff9800]" />
            <h3 className="mt-3 font-display text-base font-bold text-[#101436]">{s.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-gray-500">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="rounded-2xl bg-gradient-to-br from-[#101436] via-[#1e1b4b] to-[#312e81] p-7 text-white">
        <h3 className="font-display text-lg font-bold">Misyonumuz</h3>
        <p className="mt-2 text-sm leading-relaxed text-zinc-300">
          Bölgemizdeki her haneye ve işletmeye, hızlı, kesintisiz ve uygun fiyatlı internet erişimi sağlamak.
        </p>
        <h3 className="mt-5 font-display text-lg font-bold">Vizyonumuz</h3>
        <p className="mt-2 text-sm leading-relaxed text-zinc-300">
          Mersin ve çevresinin dijital dönüşümüne öncülük eden, en güvenilir bölgesel telekomünikasyon şirketi olmak.
        </p>
      </div>
    </LegalPage>
  );
}
